const rawFppeTaskCategories =[
    {"value":"", "label":""},
    {"value":"CHART_REVIEW", "label":"Chart Review"},
    {"value": "PROCTORING", "label":"Proctoring"},
    {"value": "OTHER", "label":"Other"},
  ];

export default rawFppeTaskCategories;